const GenderMapper = (gender) => {
    switch (gender) {
      case "man":
        return "مرد";
      case "woman":
        return "زن";
      case "both":
        return "هردو";
      default:
        return gender;
    }
  };
export default GenderMapper;